module.exports = __webpack_public_path__ + "static/media/backArrowico.57ba8115.svg";